import { useNavigate } from 'react-router-dom';
import { SearchX } from 'lucide-react';
import { AdminUI } from '../../ui/AdminUI';
import { EmptyState } from '../../components/EmptyState';

/**
 * A missing page, shown inside the app rather than instead of it.
 *
 * Previously this rendered bare — no navigation, no account menu — so mistyping
 * a URL dropped the seller onto a dead screen with the browser's back button as
 * the only way out. Keeping the shell means the wrong page is a detour, not an
 * exit.
 */
export const ErrorNotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AdminUI>
      <div className="flex min-h-[60vh] items-center justify-center">
        <EmptyState
          icon={SearchX}
          title="Page not found"
          description="The page you are looking for doesn't exist or has been moved."
          action={{ label: 'Back to dashboard', onAction: () => navigate('/') }}
          testId="error-not-found"
        />
      </div>
    </AdminUI>
  );
};
